import { Button } from '@coolblue-development/becky';
import ReplyIcon from '../../../Icons/ReplyIcon';

interface ReplyButtonProps {
  onClick: () => void;
}

const ReplyButton = ({ onClick }: ReplyButtonProps): JSX.Element => {
  return (
    <Button startIcon={<ReplyIcon />} onClick={onClick} data-testid="reply-button">
      Reply
    </Button>
  );
};

export default ReplyButton;
